import type { CodeMigration } from './types.js';

/**
 * Retroactive migration for v2.0.0-preview.380
 * Fixes App.tsx files that were generated without SmartStackProvider
 * This migration runs when upgrading FROM any version TO 2.0.0-preview.380 or later
 */
export const appTsxRetroactiveMigration: CodeMigration = {
  fromVersion: '1.0.0',
  toVersion: '2.0.0-preview.380',
  description: 'Fix App.tsx to include SmartStackProvider (retroactive fix for projects created with old templates)',

  migrations: [
    {
      pattern: '**/App.tsx',
      description: 'Wrap routes with BrowserRouter and SmartStackProvider',

      detect: (content: string): boolean => {
        // Migration needed if:
        // 1. File imports from @atlashub/smartstack
        // 2. BUT does NOT use SmartStackProvider
        const hasSmartStackImport = content.includes('@atlashub/smartstack');
        const hasSmartStackProvider = content.includes('SmartStackProvider');

        return hasSmartStackImport && !hasSmartStackProvider;
      },

      transform: (content: string): string => {
        // This migration does nothing - BrowserRouter and SmartStackProvider
        // should be in main.tsx, not App.tsx
        // App.tsx should only return useRoutes(routes)
        return content;
      }
    }
  ]
};
